import tutorial_screen1 from "../../assets/images/tutorials/tutorial_screen1.jpg";
import tutorial_screen2 from "../../assets/images/tutorials/tutorial_screen2.jpg";
import tutorial_screen3 from "../../assets/images/tutorials/tutorial_screen3.jpg";
import tutorial_screen4 from "../../assets/images/tutorials/tutorial_screen4.jpg";
import tutorial_screen5 from "../../assets/images/tutorials/tutorial_screen5.jpg";
import tutorial_screen6 from "../../assets/images/tutorials/tutorial_screen6.jpg";
import tutorial_screen7 from "../../assets/images/tutorials/tutorial_screen7.jpg";
import tutorial_screen8 from "../../assets/images/tutorials/tutorial_screen8.jpg";
import tutorial_screen9 from "../../assets/images/tutorials/tutorial_screen9.jpg";

export const row1Videos = [
    {
        id: 1,
        videoKey: "media/Organization Information & Actions.mp4",
        title: "Organization Information and Actions",
        date: "Dec 22, 2025 - 1:00 PM",
        thumbnail: tutorial_screen2
    },
    {
        id: 2,
        videoKey: "media/Organization Upload.mp4",
        title: "Organization Upload",
        date: "Jan 9, 2026 - 11:04 AM",
        thumbnail: tutorial_screen3
    },
    {
        id: 3,
        videoKey: "media/Manual Organization Add.mp4",
        title: "Manual Organization Add",
        date: "Feb 10, 2026 - 1:00 PM",
        thumbnail: tutorial_screen4
    },
];

export const row2Videos = [
    {
        id: 1,
        videoKey: "media/Manual User Add.mp4",
        title: "Manual User Add",
        date: "Dec 22, 2025 - 1:00 PM",
        thumbnail: tutorial_screen5
    },
    {
        id: 2,
        videoKey: "media/User Information & Actions.mp4",
        title: "User Information and Actions",
        date: "Dec 22, 2025 - 1:00 PM",
        thumbnail: tutorial_screen6
    },
    {
        id: 3,
        videoKey: "media/User Upload.mp4",
        title: "User Upload",
        date: "Jan 9, 2026 - 11:16 AM",
        thumbnail: tutorial_screen7
    },
];

export const row3Videos = [
    {
        id: 1,
        videoKey: "media/Message Reports.mp4",
        title: "Message Reports",
        date: "Jan 9, 2026 - 11:06 AM",
        thumbnail: tutorial_screen8
    },
    {
        id: 2,
        videoKey: "media/User Reports.mp4",
        title: "User Reports",
        date: "Dec 22, 2025 - 1:00 PM",
        thumbnail: tutorial_screen9
    },
];

export const row4Videos = [
    {
        id: 1,
        videoKey: "media/Webmail.mp4",
        title: "Webmail",
        date: "Jan 9, 2026 - 11:19 AM",
        thumbnail: tutorial_screen1
    },
];